export const field = {
  user: {
    name: 'user',
    type: 'text',
    placeholder: 'User name*',
    title: 'The name must be greater than 2 characters',
    required: true,
  },
  email: {
    name: 'email',
    type: 'text',
    placeholder: 'Електронна пошта*',
    required: true,
  },
  password: {
    name: 'password',
    type: 'password',
    placeholder: 'Пароль (від 8 символів)*',
    required: true,
    title: 'Пароль має бути не менше 8 символів',
  },
  filter: {
    type: 'text',
    name: 'filter',
    placeholder: 'Select filter value',
  },
  productName: {
    name: 'productName',
    type: 'text',
    autoComplete: 'off',
    placeholder: 'Я хочу купити...*',
  },
  price: {
    name: 'price',
    type: 'text',
    required: true,
  },
  sale: {
    name: 'sale',
    type: 'number',
    required: true,
  },
  category: {
    name: 'category',
    type: 'text',
    placeholder: 'Категорія*',
    required: true,
  },
  condition: {
    name: 'condition',
    type: 'text',
    placeholder: 'Виберіть стан*',
    required: true,
  },
  shopName: {
    name: 'shopName',
    type: 'text',
    placeholder: 'Назва закладу*',
    required: true,
  },
  description: {
    name: 'description',
    type: 'text',
    placeholder: 'Наприклад: Дуже стильна річ, стан нової...',
    required: true,
  },
  nameProduct: {
    name: 'nameProduct',
    type: 'text',
    placeholder: 'Наприклад: Джинси Calvin Klein',
    required: true,
  },
  brendName: {
    name: 'brendName',
    type: 'text',
    placeholder: 'Наприклад: Calvin Klein',
    required: true,
  },
  section: {
    name: 'section',
    type: 'text',
    placeholder: 'Розділ*',
    required: true,
  },
  quantity: {
    name: 'quantity',
    type: 'text',
    required: true,
  },
  keyWords: {
    name: 'keyWords',
    type: 'text',
    placeholder:
      'Наприклад слова, такі як: сукня, сукня zara, zara, червона сукня горошок',
    required: true,
  },
  vip: {
    name: 'vip',
    type: 'text',
    placeholder: 'Виберіть статус',
    required: true,
  },
  secondName: {
    name: 'secondName',
    type: 'text',
  },
  firstName: {
    name: 'firstName',
    type: 'text',
  },
  surName: {
    name: 'surName',
    type: 'text',
  },
  tel: {
    name: 'tel',
    type: 'text',
  },
  cityName: {
    name: 'cityName',
    type: 'text',
    placeholder: 'Київ',
  },
  streetName: {
    name: 'streetName',
    type: 'text',
  },
  houseNamber: {
    name: 'houseNamber',
  },
  sex: {
    name: 'sex',
    type: 'text',
  },
  about: {
    name: 'about',
    type: 'text',
  },
  phone: {
    name: 'phone',
    type: 'text',
  },
  delivery: {
    name: 'delivery',
    type: 'text',
    placeholder: 'Виберіть службу доставки*',
    required: true,
  },
  deliveryCity: {
    name: 'city',
    type: 'text',
  },
  deliveryDepartment: {
    name: 'department',
    type: 'text',
  },
};
